import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgComputer = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M14.5 14.5h-5a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4.5a1 1 0 0 0-1-1Zm-1 2V19h-3v-2.5h3Z" />
      <path d="M20.5 2.5h-17a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2Zm-17 2h17v10h-17v-10Z" />
      <path d="M13 12a1 1 0 0 1 .117 1.993L13 14h-2a1 1 0 0 1-.117-1.993L11 12h2ZM17 19a1 1 0 0 1 .117 1.993L17 21H7a1 1 0 0 1-.117-1.993L7 19h10Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgComputer)
const Memo = memo(ForwardRef)
export default Memo
